import React from 'react';
import ContractInternetButtonCp from "./ContractInternetButtonCp";
import plans from "../../interfaces/internetPlans.json";
import './InternetPlans.css'

function InternetPlans(): React.JSX.Element {

    return (
        <>
            {plans.internetPlans.map(item => (
                <div className="container">
                    <div className="planName">
                        <p className="planName">{item.planName}</p>
                    </div>
                    <div className="planGigas">
                        <p id="planGigas">{item.planGb}</p>
                    </div>
                    <div className="planBenefits">
                        {item.planBenefits.map((benefit, id) => (
                            <p key={id}>{benefit}</p>
                        ))}
                    </div>
                    <div>
                        <p className="planPrice">R${item.planValue}/mês</p>
                    </div>
                    <div className="contractButton">
                        <ContractInternetButtonCp />
                    </div>
                </div>
            ))}

        </>
    );
}

export default InternetPlans;